export const getChartOfAccount = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/quickbooks/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getChartOfAccountListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/quickbooks/chart-of-accounts/${queryString ? `?${queryString}` : ''}`;
};

export const getChartOfAccountCompanyNamesApi = () => {
   return `integrations/quickbooks/company_name/?source=chart_of_account`;
}